import Cookies from 'js-cookie';

/**
 * Get secure preview URL for a generation (admin version - now uses HTTP headers for authentication)
 * 
 * @param {number} generationId - The generation ID
 * @param {string} type - Optional type (e.g., 'enhanced')
 * @returns {string} - URL without token (authentication via HTTP headers)
 */
export const getAdminSecurePreviewUrl = (generationId, type = null) => {
  const { API_URLS } = require('../config/apiConfig');
  
  let baseUrl = `${API_URLS.BACKEND_BASE}/api/merchant/ai-generation/preview/${generationId}`;
  
  if (type) {
    baseUrl += `?type=${type}`;
  }
  
  return baseUrl;
};

/**
 * Get secure video stream URL for a generation (admin version - now uses HTTP headers for authentication)
 * 
 * @param {number} generationId - The generation ID
 * @returns {string} - URL without token (authentication via HTTP headers)
 */
export const getAdminSecureVideoStreamUrl = (generationId) => {
  const { API_URLS } = require('../config/apiConfig');
  
  const baseUrl = `${API_URLS.BACKEND_BASE}/api/merchant/ai-generation/video-stream/${generationId}`;
  
  return baseUrl;
};

/**
 * Pick preview (image) or video-stream URL for admin SecureImage / SecureVideo.
 */
export const getAdminGeneratedMediaUrl = (generation) => {
  if (!generation?.id) return null;
  const isVideo =
    generation.output_format_name === 'VIDEO' || Boolean(generation.generated_video_path);
  if (isVideo) {
    return getAdminSecureVideoStreamUrl(generation.id);
  }
  if (generation.watermarked_image_url) {
    const match = String(generation.watermarked_image_url).match(/\/preview\/(\d+)/);
    if (match) {
      return getAdminSecurePreviewUrl(parseInt(match[1], 10));
    }
  }
  return getAdminSecurePreviewUrl(generation.id);
};

/**
 * Get secure image URL for a generation (admin version - now uses HTTP headers for authentication)
 * 
 * @param {number} generationId - The generation ID
 * @returns {string} - URL without token (authentication via HTTP headers)
 */
export const getAdminSecureImageUrl = (generationId) => {
  const { API_URLS } = require('../config/apiConfig');
  
  const baseUrl = `${API_URLS.BACKEND_BASE}/api/merchant/ai-generation/preview/${generationId}`;
  
  return baseUrl;
};
